module.exports = __webpack_public_path__ + "img/id-number-4.24713362.svg";